@import (reference) '../../../../../constants/spacing.module.less';

.content {
  padding: @space-16;
}

.loadingContainer {
  padding: @space-32;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.loading {
  width: 100px;
  height: 100px;
}

.infoMessage {
  color: var(--blue-600);
  font-size: 14px;
  line-height: 16px;
}

.infoIcon {
  font-size: 14px;
  color: var(--blue-600);
}

.infoContainer {
  background-color: var(--blue-200);
  padding: @space-8;
  align-items: center;
}

.required {
  color: var(--red-600);
}
